<template>
    <div class="qh_warp">
        <div class="qh_header">
            <!--<a class="qh_return" onclick="window.history.go(-1)"></a>-->
        </div>
        <div class="qh_table">
            <div class="qh_title">
                <div class="t1">名称/代码</div>
                <div class="t2">
                    <div class="t2_word">最新价</div>
                    <div class="t2_btn">
                        <div :class="[price_up ? 'up_press' : '', 'up']" @click="price_up_sort"></div>
                        <div :class="[price_down ? 'down_press' : '', 'down']" @click="price_down_sort"></div>
                    </div>
                </div>
                <div class="t2">
                    <div class="t2_word">涨跌幅</div>
                    <div class="t2_btn">
                        <div :class="[range_up ? 'up_press' : '', 'up']" @click="range_up_sort"></div>
                        <div :class="[range_down ? 'down_press' : '', 'down']" @click="range_down_sort"></div>
                    </div>
                </div>
            </div>
            <ul>
                <stock-one v-for="item,i in data" :key="i" :itemData="item" :pricenow="item[0]"></stock-one>
            </ul>
        </div>
    </div>
</template>
<script>
    import DataApi from '@/api/stock_index_futures/';
    import stockOne from '@/components/stockOne/';
    export default {
        name: "stock_index_future",
        components:{
            stockOne
        },
        data(){
            return{
                price_up:false,
                price_down:false,
                range_up:false,
                range_down:false,
                data:[],
                timer:'',
            }
        },
        created(){
            this.getData();
            this.getshare();//分享
            this.timer=setInterval(
                () => {
                    this.price_up = false;
                    this.price_down = false;
                    this.range_up = false;
                    this.range_down = false;
                    this.getData();
                }, 6000);
        },
        mounted(){},
        methods:{
            async price_up_sort(){
                this.price_up = true;
                this.price_down = false;
                this.range_up = false;
                this.range_down = false;
                this.getData('current_price_asc');
            },
            async price_down_sort(){
                this.price_up = false;
                this.range_up = false;
                this.range_down = false;
                this.price_down = true;
                this.getData('current_price_desc');
            },
            async range_up_sort(){
                this.range_up = true;
                this.price_up = false;
                this.range_down = false;
                this.price_down = false;
                this.getData('price_than_asc');
            },
            async range_down_sort(){
                this.range_down = true;
                this.range_up = false;
                this.price_up = false;
                this.price_down = false;
                this.getData('price_than_desc');
            },
            async getData(sort) {
                let data = await DataApi.getStockFuture(sort);
                if(data.length>0){
                    this.data = data;
                }
            },
            async getshare() {
                let data = await DataApi.getShare();
                let share_data = {
                    share_content :'上爱股票APP，查看更多股票行情（分享自@爱股票APP）',
                    share_link :data.share_link,
                    share_logo:'https://cdncos.aigupiao.com/assets/wap/img/logo80x80.png',
                    share_title:'爱股票股指期货行情',
                    share_title_qq:'爱股票股指期货行情',
                    share_title_wx:'爱股票股指期货行情',
                    share_open:{
                        AppID:data.AppID,
                        nonceStr:data.nonceStr,
                        signature:data.signature,
                        timestamp:data.timestamp,
                        share_link :data.share_link,
                    }
                }
                console.log(share_data)
                this.$share(share_data);
            },
        },
        beforeDestroy() {
            if(this.timer) {
                clearInterval(this.timer);
            }
        }
    }
</script>

<style scoped>
    body{
        background-color: #fff!important;
    }
    .qh_header{
        width: 100%;
        height: 94px;
        background: url("https://cdncos.aigupiao.com/assets/wap/img/qh_header.png") no-repeat;
        background-size: 100% 94px;
        position: relative;
    }
/*    .qh_return{
        width: 22px;
        height: 22px;
        background: url("https://cdncos.aigupiao.com/assets/wap/img/qh_return.png");
        background-size: contain;
        position: absolute;
        top: 11px;
        left: 6px;
    }*/
    .qh_title{
        padding-left: 12px;
        height: 35px;
        display: flex;
        justify-content: space-between;
        padding-right: 14px;
        font-size: 13px;
        font-family: PingFangSC-Regular,PingFang SC,"微软雅芳";
        font-weight: 400;
        color: #636363;
        line-height: 35px;
        border-bottom: 1px solid #EBEBEB;
        background: #ffffff;
    }
    .t1{
        width: 160px;
        text-align: left;
    }
    .t2{
        width: 75px;
        display: flex;
        justify-content: flex-end;
    }

    .t2_btn{
        margin-left: 5px;
    }
    .up{
        width: 7.5px;
        height: 6px;
        background: url("https://cdncos.aigupiao.com/assets/wap/img/qh_up.png") no-repeat;
        background-size: contain;
        margin-top: 10.5px;
        margin-bottom: 3px;
    }
    .down{
        width: 7.5px;
        height: 6px;
        background: url("https://cdncos.aigupiao.com/assets/wap/img/qh_down.png") no-repeat;
        background-size: contain;
    }

    .up_press{
        background: url("https://cdncos.aigupiao.com/assets/wap/img/qh_r_u.png") no-repeat;
        background-size: contain;
    }

    .down_press{
        background: url("https://cdncos.aigupiao.com/assets/wap/img/qh_r_d.png") no-repeat;
        background-size: contain;
    }

</style>